import { Button, Stack, Typography } from "@mui/material";
import { RedirectKeys } from "../auth/authTypes";
import { useLocalization } from "../hooks/useLocalization";
import AuthenticationFailedIcon from "../icons/AuthenticationFailedIcon";
import InfoPage from "./infoPage/InfoPage";

interface Props {
  errorDetails?: string;
  buttonText?: string;
  redirectPath?: string;
}

const AuthenticationFailed = ({ errorDetails, buttonText, redirectPath }: Props) => {
  const locale = useLocalization();
  const page = locale.pages.authentication_failed;

  return (
    <InfoPage
      Icon={<AuthenticationFailedIcon />}
      title={page.title}
      subtitle={
        <Stack spacing={1} alignItems="center">
          {errorDetails && (
            <Typography variant="subtitle1" color="error">
              {errorDetails}
            </Typography>
          )}
          <Typography color="text.secondary">{page.subtitle}</Typography>
        </Stack>
      }
    >
      <Button
        href={redirectPath || `/?${RedirectKeys.Prompt}=select_account`}
        color="primary"
        variant="contained"
        sx={{ width: "10rem" }}
      >
        {buttonText || page.button}
      </Button>
    </InfoPage>
  );
};

export default AuthenticationFailed;
